import { PermissionsType } from '../../common/permissionsConst';

export const qingflowWorkDetailPath = `${window.SELECTSTAFFORIGIN}/ql/platform/${PermissionsType.P_QL_WORK_ALARM}`;

export const TabKeyEnum = {
  RESTORED_ALARM: '0',
  UNRESTORED_ALARM: '1',
};
export const TabKeyStateDisplay = {
  [TabKeyEnum.RESTORED_ALARM]: '已恢复报警',
  [TabKeyEnum.UNRESTORED_ALARM]: '未恢复报警',
};
export const GradeEnum = {
  ALL: 5,
  TOP: 0,
  HIGH: 1,
  MIDDLE: 2,
  LOW: 3,
  LOWEST: 4,
};
